$(document).on('click', '.main-collection-link', function () {
	var url = $(this).data('href');
	if (url) {
		window.location.href = url;
	}
});
document.addEventListener("DOMContentLoaded", function () {
	const phoneInputs = document.querySelectorAll(".rfq_phone");
	phoneInputs.forEach(phoneInput => {
		if (phoneInput.classList.contains("iti__tel-input")) return;
		const customerCountryName = window.RFQ_CUSTOMER?.default_address?.country || "United Arab Emirates";
		const allCountries = window.intlTelInputGlobals.getCountryData();
		let customerCountryCode = "ae"; // default
		for (let c of allCountries) {
			if (c.name.trim().toLowerCase() === customerCountryName.trim().toLowerCase()) {
				customerCountryCode = c.iso2;
				break;
			}
		}

		const iti = window.intlTelInput(phoneInput, {
			initialCountry: customerCountryCode,
			separateDialCode: true,
			nationalMode: false,
			autoPlaceholder: "polite",
			utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.5.2/build/js/utils.js"
		});

		// On load: set all country selects
		document.querySelectorAll(".rfq_country").forEach(countrySelect => {
			let matched = false;
			Array.from(countrySelect.options).forEach(opt => {
				if (opt.value.trim().toLowerCase() === customerCountryName.trim().toLowerCase()) {
					countrySelect.value = opt.value;
					matched = true;
				}
			});
			if (!matched) {
				Array.from(countrySelect.options).forEach(opt => {
					if (opt.value.trim().toLowerCase() === "united arab emirates") {
						countrySelect.value = opt.value;
					}
				});
			}
		});

		// Listen to country change on this phone input
		phoneInput.addEventListener("countrychange", function () {
			const data = iti.getSelectedCountryData();
			if (!data || !data.name) return;

			const selectedName = data.name.trim().toLowerCase();

			// 1️⃣ Update all country selects
			document.querySelectorAll(".rfq_country").forEach(countrySelect => {
				let matched = false;
				Array.from(countrySelect.options).forEach(opt => {
					if (opt.value.trim().toLowerCase() === selectedName) {
						countrySelect.value = opt.value;
						matched = true;
					}
				});
				if (matched) {
					countrySelect.dispatchEvent(new Event("change", { bubbles: true }));
				}
			});

			// 2️⃣ Update all other phone inputs to same country
			phoneInputs.forEach(otherPhone => {
				if (otherPhone === phoneInput) return; // skip the one that triggered
				const otherIti = window.intlTelInputGlobals.getInstance(otherPhone);
				if (otherIti) {
					otherIti.setCountry(data.iso2);
				}
			});
		});
	});
});
let drawerSource = null;

$(".category-icon").on("click", function () { 
	console.log(1111);
	$('.header__icon--summary').trigger('click');
	$(this).addClass('open');
    $('body').removeClass('main-menu').addClass('category-menu');
});

$(".icon-hamburger").click(function(){
	console.log(2222);
	$('body').removeClass('category-menu').addClass('main-menu');
});